import Immutable from 'immutable';

import { userDetail } from "./auth";

const SUBSCRIBE = 'subscription/SUBSCRIBE';
const SUBSCRIBE_SUCCESS = 'subscription/SUBSCRIBE_SUCCESS';
const SUBSCRIBE_FAIL = 'subscription/SUBSCRIBE_FAIL';

const CARD = 'subscription/CARD';
const CARD_SUCCESS = 'subscription/CARD_SUCCESS';
const CARD_FAIL = 'subscription/CARD_FAIL';

const COUPON = 'subscription/COUPON';
const COUPON_SUCCESS = 'subscription/COUPON_SUCCESS';
const COUPON_FAIL = 'subscription/COUPON_FAIL';

const DOWNGRADE = 'subscription/DOWNGRADE';
const DOWNGRADE_SUCCESS = 'subscription/DOWNGRADE_SUCCESS';
const DOWNGRADE_FAIL = 'subscription/DOWNGRADE_FAIL';

const CUSTOMER = 'subscription/CUSTOMER';
const CUSTOMER_SUCCESS = 'subscription/CUSTOMER_SUCCESS';
const CUSTOMER_FAIL = 'subscription/CUSTOMER_FAIL';

const APPSUMOCODE = 'subscription/APPSUMOCODE';
const APPSUMOCODE_SUCCESS = 'subscription/APPSUMOCODE_SUCCESS';
const APPSUMOCODE_FAIL = 'subscription/APPSUMOCODE_FAIL';

const initialState = Immutable.fromJS({
  user: null,
  paymentDone: false,
  loading: false,
  subscribeError: null,
  customer: null,
  appsumocode: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SUBSCRIBE:
      return state
        .set('customerId', null)
        .set('loading', true)
        .set('paymentDone', false)
        .set('subscribeError', null)
        .set('downgradeDone', false);

    case SUBSCRIBE_SUCCESS:
      return state
        .set('customerId', action.success.stripeCustomerId)
        .set('loading', false)
        .set('subscribeError', null)
        .set('paymentDone', true)
        .set('downgradeDone', false);

    case SUBSCRIBE_FAIL:
      return state
        .set('customerId', null)
        .set('loading', false)
        .set('subscribeError', action.error)
        .set('downgradeDone', false);

    case CARD:
      return state
        .set('loading', true)
        .set('cardError', null);

    case CARD_SUCCESS:
      return state
        .set('customer', action.success.customer)
        .set('loading', false)
        .set('cardError', null);

    case CARD_FAIL:
      return state
        .set('loading', false)
        .set('cardError', action.error);

    case COUPON:
      return state
        .set('loading', true)
        .set('couponError', null);

    case COUPON_SUCCESS:
      return state
        .set('customer', action.success.customer)
        .set('loading', false)
        .set('couponError', null);

    case COUPON_FAIL:
      return state
        .set('loading', false)
        .set('couponError', action.error);

    case DOWNGRADE:
      return state
        .set('customerId', null)
        .set('loading', true)
        .set('paymentDone', false)
        .set('subscribeError', null)
        .set('downgradeDone', false);

    case DOWNGRADE_SUCCESS:
      return state
        .set('customerId', null)
        .set('loading', false)
        .set('subscribeError', null)
        .set('paymentDone', false)
        .set('downgradeDone', true);

    case DOWNGRADE_FAIL:
      return state
        .set('customerId', null)
        .set('loading', false)
        .set('subscribeError', action.error)
        .set('paymentDone', false)
        .set('downgradeDone', false);

    case CUSTOMER:
      return state
        .set('customer', null)
        .set('loading', true);

    case CUSTOMER_SUCCESS:
      return state
        .set('customer', action.success.customer)
        .set('loading', false);

    case CUSTOMER_FAIL:
      return state
        .set('customer', null)
        .set('loading', false);

    case APPSUMOCODE:
      return state
        .set('loading', true)
        .set('appsumoError', null);

    case APPSUMOCODE_SUCCESS:
      return state
        .set('appsumocode', action.success)
        .set('loading', false)
        .set('appsumoError', action.error);

    case APPSUMOCODE_FAIL:
      return state
        .set('loading', false)
        .set('appsumoError', action.error);

    default:
      return state;
  }
}

export const subscribe = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: SUBSCRIBE });
  try {
    const res = await api.post('/payment', { data: obj });
    if(res.message)
      return dispatch({ type: SUBSCRIBE_FAIL, error: res.message });

    dispatch({ type: SUBSCRIBE_SUCCESS, success: res });
  } catch (err) {
    dispatch({ type: SUBSCRIBE_FAIL, error: err.message });
  }
};

export const card = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: CARD });
  try {
    const res = await api.post('/payment/card', { data: obj });
    if(res.message)
      return dispatch({ type: CARD_FAIL, error: res.message });

    return dispatch({ type: CARD_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: CARD_FAIL, error: err.message });
  }
};

export const downgrade = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: DOWNGRADE });
  try {
    const res = await api.post('/payment/downgrade', { data: obj });
    if(res.message)
      return dispatch({ type: DOWNGRADE_FAIL, error: res.message });

    return dispatch({ type: DOWNGRADE_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: DOWNGRADE_FAIL, error: err.message });
  }
};

export const customer = () => async (dispatch, getState, api) => {
  dispatch({ type: CUSTOMER });
  try {
    const res = await api.get('/payment/customer');
    if(res.message)
      return dispatch({ type: CUSTOMER_FAIL, error: res.message });

    return dispatch({ type: CUSTOMER_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: CUSTOMER_FAIL, error: err.message });
  }
};


export const updatePlan = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: DOWNGRADE });
  try {
    const res = await api.post('/payment/updatePlan', { data: obj });
    if(res.message)
      return dispatch({ type: DOWNGRADE_FAIL, error: res.message });

    return dispatch({ type: DOWNGRADE_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: DOWNGRADE_FAIL, error: err.message });
  }
};


export const coupon = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: COUPON });
  try {
    const res = await api.post('/payment/coupon', { data: obj });
    if(res.message)
      return dispatch({ type: COUPON_FAIL, error: res.message });

    return dispatch({ type: COUPON_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: COUPON_FAIL, error: err.message });
  }
};


export const getAppliedAppSumoCodes = () => async (dispatch, getState, api) => {
  dispatch({ type: APPSUMOCODE });
  try {
    const res = await api.get('/appsumo/appsumocodes');
    if(res.errMessage) {
      return dispatch({ type: APPSUMOCODE_FAIL, error: res.errMessage });
    }

    return dispatch({ type: APPSUMOCODE_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: APPSUMOCODE_FAIL, error: err.message });
  }
};

export const updateCode = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: APPSUMOCODE });
  try {
    const res = await api.put('/appsumo/appsumocodes',  { data: obj });
    if(res.errMessage) {
      return dispatch({ type: APPSUMOCODE_FAIL, error: res.errMessage });
    }

    await dispatch(userDetail(true));
    return dispatch({ type: APPSUMOCODE_SUCCESS, success: res });
  } catch (err) {
    return dispatch({ type: APPSUMOCODE_FAIL, error: err.message });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/subscription.js